<template>
  <div class="movie-card card-200">
    <img
        class="movie-card-img card-200-image position-absolute w-100 h-100 rounded-sm"
        :alt="alt"
        :src="image"
    />
    <div class="content position-absolute card-200-content-wrapper">
      <slot name="p-1">
        <h3 class="font-weight-bolder">عنوان فیلم</h3>
        <p class="font-weight-bold">قسمت چند</p>
        <button class="btn btn-primary border-0 rounded-sm py-1">
          <i class="bi bi-play btn-icon"></i>
          دانلود
        </button>
      </slot>
    </div>
  </div>
</template>

<script>
import mA from "../Tags/A";
import mImg from "../Tags/Img";
import {CardProps} from "./CardProps";

export default {
  name: "Card922",
  components: {
    mA,
    mImg,
  },
  props: {
    ...CardProps,
  },
};
</script>

<style scoped>
.movie-card {
  color: rgba(226, 232, 240, 0.87);
  scale: 0.98;
  transition-duration: 300ms;
  height: 320px;
  width: 100%;
}

.movie-card:hover {
  cursor: pointer;
  transition-duration: 300ms;
  transform: scale3d(1.1, 1.1, 1) perspective(31.25em);
}

.movie-card-img {
  object-fit: cover;
  top: 0;
  right: 0;
  z-index: -1;
  filter: brightness(0.5);
  box-shadow: 0 0 0.73em rgba(0, 0, 0, 1);
  transition-duration: 300ms;
}

.movie-card-img:hover {
  filter: brightness(0.8);
  transition-duration: 300ms;
}

.content {
  text-align: start;
  bottom: 0;
  right: 20;
  margin-bottom: 15px;
}

.content button {
  width: 90px;
}

.btn-icon {
  font-size: 1.5rem;
}
</style>
